import { StepState, WizardState } from "./types";

// export const getCurrentStep = (currentState: WizardState) =>

export const isFirstStep = (c: WizardState) => c.stepIndex === 0;

export const isLastStep = (c: WizardState) => c.stepIndex === c.steps.length - 1;

export const isForward = (index: number, previous: number) => index > previous;
export const isBackwards = !isForward;

// export const canStep = (index: number, previous: number, step: StepState) =>
//   isForward(index, previous) ? step.complete : true;
